import { StaticImage } from 'gatsby-plugin-image';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import {
  totalCartItemsSelector,
  showAddToCartTooltipSelector,
  cartZendeskIdSelector,
} from '../../../redux/selectors/cartSelectors';
import { updateShowAddToCartTooltip } from '../../../redux/reducers/cartReducer';
import { ShoppingCart, ShoppingCartStatus, Popup } from './styles';

interface ShoppingCartHeaderIcon {
  className?: string
}

const ShoppingCartHeaderIcon = ({ className }: ShoppingCartHeaderIcon) => {
  const { siteHeaderEN, siteHeaderFR } = useStaticQuery(siteHeaderQuery);

  const totalCartItems = useSelector(totalCartItemsSelector);
  const showAddToCartTooltip = useSelector(showAddToCartTooltipSelector);
  const zendeskId = useSelector(cartZendeskIdSelector);
  const dispatch = useDispatch();
  const intl = useIntl();
  const siteHeader = intl.locale === 'fr' ? siteHeaderFR : siteHeaderEN;

  useEffect(() => {
    let hidePopupTimer;
    if (showAddToCartTooltip) {
      hidePopupTimer = setTimeout(() => {
        dispatch(updateShowAddToCartTooltip(false));
      }, 5000);
    }
    return () => {
      clearTimeout(hidePopupTimer);
    };
  }, [dispatch, showAddToCartTooltip]);

  useEffect(() => () => {
    dispatch(updateShowAddToCartTooltip(false));
  }, [dispatch]);

  return (
    <ShoppingCart
      to={`/${intl.locale}/cart`}
      className={className}
      data-ga="cta-basket icon-nav"
      aria-label={siteHeader?.shoppingCartAriaLabel}
    >
      <StaticImage
        src="../../../images/shopping-cart.svg"
        alt=""
        role="presentation"
      />
      {!!totalCartItems && !zendeskId && (
        <ShoppingCartStatus
          className={className}
          data-testid="shopping-cart-status"
        >
          <span data-testid="cart-item-count">{totalCartItems}</span>
        </ShoppingCartStatus>
      )}
      {showAddToCartTooltip && siteHeader?.shoppingCartBubble && (
        <Popup
          aria-hidden={!showAddToCartTooltip}
          data-testid="shopping-cart-tooltip"
        >
          {siteHeader?.shoppingCartBubble}
        </Popup>
      )}
    </ShoppingCart>
  );
};

const siteHeaderQuery = graphql`
  query ShoppingCartBubbleQuery {
    siteHeaderEN: contentfulHeader(
      contentful_id: { eq: "32WWiqIbDJlMo8yi7SJ000" }
      node_locale: { eq: "en-CA" }
    ) {
      shoppingCartBubble
      shoppingCartAriaLabel
    }
    siteHeaderFR: contentfulHeader(
      contentful_id: { eq: "32WWiqIbDJlMo8yi7SJ000" }
      node_locale: { eq: "fr-CA" }
    ) {
      shoppingCartBubble
      shoppingCartAriaLabel
    }
  }
`;

export default ShoppingCartHeaderIcon;
